var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var colors = require("./../../../shared/colors/colors.js");

if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var SymbolGeneratorToolStateMachine = require("./symbolGeneratorToolStateMachine.js");

var SymbolGeneratorToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        cTop: 2,
        cBottom: 2,
        cLeft: 6,
        cRight: 6,
        strokeWidth: 2,
        terminalColor: colors.terminalFill
    });

    editor_2d.AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SymbolGeneratorToolController, editor_2d.AbstractToolController);
SymbolGeneratorToolController.inject = lib_core.clone(editor_2d.AbstractToolController.inject);
SymbolGeneratorToolController.StateMachineClass = SymbolGeneratorToolStateMachine;


module.exports = SymbolGeneratorToolController;

SymbolGeneratorToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Symbol Generator',
        title: 'Symbol Generator',
        style: {
            icon: 'icon-generator-symbol.svg'
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
